export class ActionItemRegisterConstants{
    public static readonly ActionItemLibraryTitle: string = 'Action Item Register';
    public static readonly ActionItemSearch_Place_Holder_Text: string = 'Search by Number, Title or Description';
      
    //error Messages
    public static readonly ActionItemRegister_Page_Validation: string = 'You do not have access to this page.';

    public static readonly ActionItem_Search_Text: string = "searchText";  
    public static readonly ActionItem_Search_Status_Text: string = "status";
    public static readonly ActionItem_Search_Type_Text: string = "type";
    public static readonly ActionItem_Search_AssignedUser_Text: string = "assignedUser";
    public static readonly ActionItem_Search_Verifier_Text: string = "verifier";
    public static readonly ActionItem_Search_DueDate_Text: string = "dueDate";


    // Toaster Messages and Severity
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Info: string = 'info';
    public static readonly Severity_Err: string = 'error';
    public static readonly Severity_Warning: string = 'warn';
    public static readonly ActionItemSearchEmpty_Filters:string = 'At least one search criterion must be defined';
}